import Mask from './maskUtils';

/**
 * Automatically format an input as a user types
 * Currently the only options set the string used as a seperator and position it
 * Only numbers are allowed.
 * TODO: add more robust options.
 * @example `v-mask="{pattern: '###-###-####', separator: '-'}"`
 * @type {Mask}
 */

export default {
    bind(el, binding) {
        el.mask = new Mask(el, {
            pattern: binding.value.pattern,
            separator: binding.value.separator,
        });
        el.mask.init();
    },

};



// WEBPACK FOOTER //
// ./source/components/directives/mask.js